import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import { cmscontentURL } from '../Config/Config';

import { GET_FORMLIST,GET_ACTIVATEFORM } from '../../actions';
var Parser = require('html-react-parser');
class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      formlist:'',
      totalRecord:0
    };

    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id
    };

    this.props.getFormList(qs.stringify(postobject));

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);


    }

   
   componentDidMount() {
      document.title = PageTitle('Formbuilder List');
      if(localStorage.getItem('admin_id') === null){
       this.props.history.push('/');
      }
   }

    handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});

      var qs = require('qs');

      var admin_id = localStorage.getItem("admin_id");

      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
      this.props.getFormList(qs.stringify(postobject))
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    
  }
   handleFormSubmit = () => {
        
          this.setState({Loading:true});
          var qs = require('qs');
          const formPayload = this.state;
           var admin_id = localStorage.getItem("admin_id");
          var postObject = {             
            activePage   : 1,
            search_all : formPayload.search_all,
            admin_id: admin_id         
          };
          //console.log(postObject);
          this.props.getFormList(qs.stringify(postObject));
        
    } 


   componentWillReceiveProps(Props){

    if (Object.keys(Props.formlist).length > 0) {
      if (Props.formlist[0]["status"] === "success") {
       
         this.setState({ totalRecord : Props.formlist[0].records_count, formlist: Props.formlist[0]["formlist"] }, function() {
            this.formlist();
         });
      }
    }
	
	if(Props.priorityupdate !==  this.props.priorityupdate){
      if (Props.priorityupdate[0]["status"] === "success") {
         this.props.getFormList();
      }
    }

      if(Props.formactive !== this.props.formactive){
      if (Props.formactive[0]["status"] === "success") {
              var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              this.props.getFormList(qs.stringify(postobject));

      }
    }

	
   }
   
activateuser(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };
      this.props.getActivateForm(qs.stringify(postObject));
}
  formlist() {

    var formlist = this.props.formlist[0];
    if (formlist != "undefined" && formlist != null) {

      if (formlist.status == "success") {

        if (Object.keys(formlist).length > 0) {
          const vehiclelistDetails = formlist.formlist.map(
            (formlist, Index) => {
              let sno = Index+1;
              if(formlist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
               if(formlist. form_column == 1){
                var column = 'One Column';
              }else{
                  column = 'Two Column';
              }


			       var istyle = { width: 100};
              return (
                <tr key={formlist.id}>
                    <td>{sno}</td>
                    <td>{formlist.form_name}</td>
                    <td>{column}</td>
                    <td>{status}</td>
                     {localStorage.getItem('loggedas') === 'admin' &&
                      <> 
                    <td className="actiongroup">
                      <Link to={{ pathname: '/formbuilder/edit/'+formlist.id}} className="" title="Duplicate">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                       {(status == 'Active'?<Link onClick={this.activateuser.bind(this, formlist.id, status)} className="" title="Status"><i className="fa fa-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateuser.bind(this, formlist.id, status)} className="" title="Status"><i className="fa fa-lock" aria-hidden="true"></i></Link>)}     
                    </td>
                    </>}
                </tr>
              );
            }
          );
          return vehiclelistDetails;
        }
      } else {

        return (
          <tr>
            <td colspan="6" className="v-align-nr">
              No Result
            </td>
          </tr>
        );

      }
    }

  }
  
  render() {

    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="formbuilder" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Forms</h3>
                </div>

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div> 
                  <div className="add_button">  
                      <a className="add" href='/form-add'>Add</a> 
                  </div>
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Form Name</th>
                      <th>Form Layout</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.formlist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formlist: state.formlist,
    formactive: state.formactive
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getFormList: (formVal) =>{
       dispatch({ type: GET_FORMLIST, formVal});
    },
    getActivateForm: (formPayload) =>{
      dispatch({ type: GET_ACTIVATEFORM, formPayload });
    },
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));